import { useHidePIIInfo } from "./useHidePIIInfo";

export const MaskPIIInfo = (value: string | number, visibleChars = 4) => {
  const hidePIIInfo = useHidePIIInfo();
  const visibleCharsAbs = Math.abs(visibleChars);

  if (!value || !["string", "number"].includes(typeof value)) return "";

  const stringValue = String(value);
  if (visibleCharsAbs > stringValue.length)
    return "*".repeat(stringValue.length);

  const maskedValue =
    "*".repeat(stringValue.length - visibleCharsAbs) +
    (visibleCharsAbs > 0 ? stringValue.slice(-visibleCharsAbs) : "");

  return hidePIIInfo ? maskedValue : stringValue;
};
